import type { FieldId } from '@atlassian/jira-ui-modifications-fields-configuration/src/common/utils/common';
import type { AppId, ChangeId, RegisteredFieldsMap } from '../../../types';

export const findAppsToBufferForChangeId = ({
	registeredFieldsMap,
	changeId,
}: {
	registeredFieldsMap: RegisteredFieldsMap;
	changeId: ChangeId;
}) => {
	const fieldsRegisteredByApps: Record<FieldId, Set<AppId>> = {};
	const appsToBuffer: Set<AppId> = new Set();

	Object.entries(registeredFieldsMap).forEach(([appId, appRegisteredFields]) => {
		const fields = appRegisteredFields?.[changeId];
		if (!fields) {
			return;
		}

		fields.forEach((fieldId) => {
			if (fieldsRegisteredByApps[fieldId]) {
				fieldsRegisteredByApps[fieldId].add(appId);

				fieldsRegisteredByApps[fieldId].forEach((applicationId) => appsToBuffer.add(applicationId));
			} else {
				fieldsRegisteredByApps[fieldId] = new Set<AppId>();
				fieldsRegisteredByApps[fieldId].add(appId);
			}
		});
	});

	return appsToBuffer;
};
